 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHTPAGE from '@/components/Text/CopyrightPage'
 import TEXTGPRE from '@/components/Text/GPRE'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTAPRE from '@/components/Text/APRE'
 import TEXTABR from '@/components/Text/ABR'
 import TEXTINT from '@/components/Text/INT'
 import TEXTCH1 from '@/components/Text/CH1'
 import TEXTCH2 from '@/components/Text/CH2'
 import TEXTCH3 from '@/components/Text/CH3'
 import TEXTCH4 from '@/components/Text/CH4'
 import TEXTCH5 from '@/components/Text/CH5'
 import TEXTCH6 from '@/components/Text/CH6'
 import TEXTCH7 from '@/components/Text/CH7'
 import TEXTCH8 from '@/components/Text/CH8'
 import TEXTCH9 from '@/components/Text/CH9'
 import TEXTCH10 from '@/components/Text/CH10'
 import TEXTCH11 from '@/components/Text/CH11'
 import TEXTCH12 from '@/components/Text/CH12'
 import TEXTCH13 from '@/components/Text/CH13'
 import TEXTCH14 from '@/components/Text/CH14'
 import TEXTCH15 from '@/components/Text/CH15'
 import TEXTCH16 from '@/components/Text/CH16'
 import TEXTSTG from '@/components/Text/STG'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTFINDINGTHETEXTBOOKYOUNEED from '@/components/Text/FindingtheTextbookYouNeed'
 import TEXTALSOAVAILABLE from '@/components/Text/AlsoAvailable'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/APRE",
 			"name" : "Text/APRE",
 			"component" : TEXTAPRE
 		},
 		{
 			"path" : "/Text/ABR",
 			"name" : "Text/ABR",
 			"component" : TEXTABR
 		},
 		{
 			"path" : "/Text/INT",
 			"name" : "Text/INT",
 			"component" : TEXTINT
 		},
 		{
 			"path" : "/Text/CH1",
 			"name" : "Text/CH1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/CH2",
 			"name" : "Text/CH2",
 			"component" : TEXTCH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js